// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body.absence-list-route .home-header .logo {
    margin-top: 0 !important;
    margin-left: 0 !important;
    margin-right: auto !important;
    margin-bottom: 0 !important;
    width: auto;
    height: auto;
    min-height: 0;
    background: none !important;
    display: inline-flex;
    align-items: baseline;
    gap: 0;
    line-height: 1;
    text-transform: none;
    font-family: 'Poppins' !important;
    justify-content: flex-start;
    text-align: left;
    align-self: center;
}

body.absence-list-route .home-header .logo::before {
    content: 'Agema';
    color: #1f1f1f;
    font-size: 36px;
    font-weight: 500;
    letter-spacing: 0;
}

body.absence-list-route .home-header .logo::after {
    content: 'HOME';
    color: #2280b3;
    font-size: 36px;
    font-weight: 700;
    letter-spacing: 0;
}

body.absence-list-route .green-dot-web {
    width: 24px !important;
    height: 24px !important;
    color: #2382b4 !important;
    font-size: 24px !important;
    opacity: 1;
    display: inline-block;
}

body.absence-list-route .not-mobile .absence-type-cell {
    display: inline-flex;
    align-items: center;
    gap: 10px;
}

body.absence-list-route .not-mobile .absence-type-icon {
    width: 28px;
    height: 28px;
    flex: 0 0 28px;
    filter: brightness(0) saturate(100%) invert(28%) sepia(87%)
        saturate(1384%) hue-rotate(176deg) brightness(89%) contrast(88%);
}

body.absence-list-route .not-mobile .absence-type-cell-rejected .absence-type-icon {
    filter: brightness(0) saturate(100%) invert(58%) sepia(49%)
        saturate(1936%) hue-rotate(324deg) brightness(99%) contrast(89%);
}

@media only screen and (max-width: 1024px) {
    body.absence-list-route .home-header .home-desktop-menu {
        display: none !important;
    }

    body.absence-list-route .home-header .home-burger-menu {
        display: none !important;
    }

    body.absence-list-route .home-header .navbarContainer {
        padding: 10px 12px 10px 16px;
        height: 74px;
        border-bottom: 1px solid #d9dee5;
        background: #ffffff;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    body.absence-list-route .home-header .logo {
        margin-top: 0 !important;
        margin-left: 0 !important;
        margin-right: auto !important;
        margin-bottom: 0 !important;
        width: auto;
        height: auto;
        min-height: 0;
        background: none !important;
        display: inline-flex;
        align-items: baseline;
        gap: 0;
        line-height: 1;
        text-transform: none;
        font-family: 'Poppins' !important;
        justify-content: flex-start;
        text-align: left;
        align-self: center;
    }

    body.absence-list-route .home-header .logo::before {
        content: 'Agema';
        color: #1f1f1f;
        font-size: clamp(34px, 8vw, 58px);
        font-weight: 500;
        letter-spacing: -0.02em;
    }

    body.absence-list-route .home-header .logo::after {
        content: 'HOME';
        color: #2280b3;
        font-size: clamp(34px, 8vw, 58px);
        font-weight: 700;
        letter-spacing: -0.02em;
    }

    body.absence-list-route .home-header .mobile-header-actions {
        margin-left: 12px;
        display: inline-flex;
        align-items: center;
        gap: 0;
    }

    body.absence-list-route .home-header .add-btn-header-outline {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: 3px solid #1f84b9;
        background: #f3f8fb;
        box-shadow:
            0 0 0 4px rgba(31, 132, 185, 0.2),
            0 6px 14px rgba(31, 132, 185, 0.35);
    }

    body.absence-list-route .home-header .add-btn-header-outline svg {
        font-size: 24px;
        color: #1f84b9 !important;
    }

    .only-mobile .padding-body-small {
        padding: 18px 16px 12px;
    }

    .only-mobile .holiday-info,
    .only-mobile .holiday-toggle,
    .only-mobile p,
    .only-mobile .bodySmall {
        color: #1177ad;
    }

    .only-mobile .holiday-label {
        color: #1177ad;
    }

    .only-mobile .holiday-info {
        font-size: clamp(15px, 2.2vw, 33px);
        margin-top: 6px;
        line-height: 1.18;
    }

    .only-mobile .mt-5 {
        margin-top: 6px;
    }

    .only-mobile .white-progress {
        height: 6px;
        border-radius: 4px;
        background-color: #d8e2ea;
    }

    .only-mobile .white-progress .MuiLinearProgress-bar {
        background-color: #1f86ba !important;
    }

    .only-mobile .holiday-toggle {
        margin-top: 4px;
        font-size: clamp(14px, 2.1vw, 22px);
    }

    .only-mobile .absence-list p b {
        font-size: clamp(16px, 2.8vw, 24px);
        line-height: 1.15;
        color: #1177ad;
    }

    .only-mobile .home-container3 {
        gap: 12px;
        display: grid;
        grid-template-columns: 1fr;
    }

    .only-mobile .absence-card-box {
        background-color: #dfeaf2;
        border-radius: 12px;
        padding: 22px 14px;
        gap: 12px;
    }

    .only-mobile .absence-item-content.slid {
        transform: translateX(-70px);
    }

    .only-mobile .absence-card-left {
        flex: 0 0 76px;
    }

    .only-mobile .absence-type-icon {
        width: 62px;
        height: 62px;
    }

    .only-mobile .absence-card-center .feature-card-text {
        margin-bottom: 10px;
        line-height: 1.1;
        font-size: clamp(16px, 2.9vw, 38px);
    }

    .only-mobile .absence-card-center .feature-card-text a,
    .only-mobile .absenceLink {
        color: #27aae4 !important;
        font-weight: 700;
    }

    .only-mobile .absenceApprovedLink {
        color: #27aae4 !important;
        font-weight: 700;
    }

    .only-mobile .absenceRejectLink {
        color: #ef6a55 !important;
        font-weight: 700;
    }

    .only-mobile .absence-card-center .bodySmall {
        color: #0d4d8d;
        line-height: 1.25;
        font-size: clamp(14px, 2.2vw, 28px);
    }

    .only-mobile .status-icon {
        font-size: 46px !important;
        color: #2382b4 !important;
        opacity: 1;
        transform: none;
    }

    .only-mobile .absence-card-box-rejected {
        background-color: #f8e4e1;
    }

    .only-mobile .absence-card-box-approved .absence-type-icon,
    .only-mobile .absence-card-box-pending .absence-type-icon {
        filter: brightness(0) saturate(100%) invert(28%) sepia(87%)
            saturate(1384%) hue-rotate(176deg) brightness(89%) contrast(88%);
    }

    .only-mobile .absence-card-box-rejected .absence-type-icon {
        filter: brightness(0) saturate(100%) invert(58%) sepia(49%)
            saturate(1936%) hue-rotate(324deg) brightness(99%) contrast(89%);
    }

    .only-mobile .absence-card-box-rejected .feature-card-text,
    .only-mobile .absence-card-box-rejected .feature-card-text a,
    .only-mobile .absence-card-box-rejected .bodySmall,
    .only-mobile .absence-card-box-rejected .bodySmall b,
    .only-mobile .absence-card-box-rejected .absenceRejectLink {
        color: #ef6a55 !important;
    }

    .only-mobile .absence-card-box-rejected .status-icon {
        color: #ef6a55 !important;
    }

    .only-mobile .reject-status-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }

    .only-mobile .reject-status-icon svg {
        width: 46px;
        height: 46px;
        display: block;
    }
}

@media only screen and (max-width: 520px) {
    body.absence-list-route .home-header .logo::before,
    body.absence-list-route .home-header .logo::after {
        font-size: 36px;
    }

    .only-mobile .absence-list p b {
        font-size: 18px;
    }
}

@media (prefers-color-scheme: dark) and (max-width: 1024px) {
    body.absence-list-route .home-header .navbarContainer {
        background: #11161d !important;
        border-bottom: 1px solid #26313b;
    }

    body.absence-list-route .home-header .logo::before {
        color: #f1f5f9;
    }

    body.absence-list-route .home-header .add-btn-header-outline {
        background: #17222c;
    }

    body.absence-list-route .absence-list,
    body.absence-list-route .home-hero,
    body.absence-list-route .home-container {
        background: #0b1016 !important;
    }

    body.absence-list-route .only-mobile .padding-body-small {
        background: #0b1016;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/absenceList/absenceListComponent.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,6BAA6B;IAC7B,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,aAAa;IACb,2BAA2B;IAC3B,oBAAoB;IACpB,qBAAqB;IACrB,MAAM;IACN,cAAc;IACd,oBAAoB;IACpB,iCAAiC;IACjC,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,0BAA0B;IAC1B,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd;wEACoE;AACxE;;AAEA;IACI;wEACoE;AACxE;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,4BAA4B;QAC5B,YAAY;QACZ,gCAAgC;QAChC,mBAAmB;QACnB,aAAa;QACb,mBAAmB;QACnB,2BAA2B;IAC/B;;IAEA;QACI,wBAAwB;QACxB,yBAAyB;QACzB,6BAA6B;QAC7B,2BAA2B;QAC3B,WAAW;QACX,YAAY;QACZ,aAAa;QACb,2BAA2B;QAC3B,oBAAoB;QACpB,qBAAqB;QACrB,MAAM;QACN,cAAc;QACd,oBAAoB;QACpB,iCAAiC;QACjC,2BAA2B;QAC3B,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd,iCAAiC;QACjC,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,cAAc;QACd,iCAAiC;QACjC,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,iBAAiB;QACjB,oBAAoB;QACpB,mBAAmB;QACnB,MAAM;IACV;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,yBAAyB;QACzB,mBAAmB;QACnB;;+CAEuC;IAC3C;;IAEA;QACI,eAAe;QACf,yBAAyB;IAC7B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;;;;QAII,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,mCAAmC;QACnC,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,yBAAyB;IAC7B;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,eAAe;QACf,mCAAmC;IACvC;;IAEA;QACI,mCAAmC;QACnC,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,SAAS;QACT,aAAa;QACb,0BAA0B;IAC9B;;IAEA;QACI,yBAAyB;QACzB,mBAAmB;QACnB,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,mCAAmC;IACvC;;IAEA;;QAEI,yBAAyB;QACzB,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;QACzB,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;QACzB,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,iBAAiB;QACjB,mCAAmC;IACvC;;IAEA;QACI,0BAA0B;QAC1B,yBAAyB;QACzB,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI;4EACoE;IACxE;;IAEA;QACI;4EACoE;IACxE;;IAEA;;;;;QAKI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,oBAAoB;QACpB,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,cAAc;IAClB;AACJ;;AAEA;IACI;;QAEI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,8BAA8B;QAC9B,gCAAgC;IACpC;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;;;QAGI,8BAA8B;IAClC;;IAEA;QACI,mBAAmB;IACvB;AACJ","sourcesContent":["body.absence-list-route .home-header .logo {\r\n    margin-top: 0 !important;\r\n    margin-left: 0 !important;\r\n    margin-right: auto !important;\r\n    margin-bottom: 0 !important;\r\n    width: auto;\r\n    height: auto;\r\n    min-height: 0;\r\n    background: none !important;\r\n    display: inline-flex;\r\n    align-items: baseline;\r\n    gap: 0;\r\n    line-height: 1;\r\n    text-transform: none;\r\n    font-family: 'Poppins' !important;\r\n    justify-content: flex-start;\r\n    text-align: left;\r\n    align-self: center;\r\n}\r\n\r\nbody.absence-list-route .home-header .logo::before {\r\n    content: 'Agema';\r\n    color: #1f1f1f;\r\n    font-size: 36px;\r\n    font-weight: 500;\r\n    letter-spacing: 0;\r\n}\r\n\r\nbody.absence-list-route .home-header .logo::after {\r\n    content: 'HOME';\r\n    color: #2280b3;\r\n    font-size: 36px;\r\n    font-weight: 700;\r\n    letter-spacing: 0;\r\n}\r\n\r\nbody.absence-list-route .green-dot-web {\r\n    width: 24px !important;\r\n    height: 24px !important;\r\n    color: #2382b4 !important;\r\n    font-size: 24px !important;\r\n    opacity: 1;\r\n    display: inline-block;\r\n}\r\n\r\nbody.absence-list-route .not-mobile .absence-type-cell {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n}\r\n\r\nbody.absence-list-route .not-mobile .absence-type-icon {\r\n    width: 28px;\r\n    height: 28px;\r\n    flex: 0 0 28px;\r\n    filter: brightness(0) saturate(100%) invert(28%) sepia(87%)\r\n        saturate(1384%) hue-rotate(176deg) brightness(89%) contrast(88%);\r\n}\r\n\r\nbody.absence-list-route .not-mobile .absence-type-cell-rejected .absence-type-icon {\r\n    filter: brightness(0) saturate(100%) invert(58%) sepia(49%)\r\n        saturate(1936%) hue-rotate(324deg) brightness(99%) contrast(89%);\r\n}\r\n\r\n@media only screen and (max-width: 1024px) {\r\n    body.absence-list-route .home-header .home-desktop-menu {\r\n        display: none !important;\r\n    }\r\n\r\n    body.absence-list-route .home-header .home-burger-menu {\r\n        display: none !important;\r\n    }\r\n\r\n    body.absence-list-route .home-header .navbarContainer {\r\n        padding: 10px 12px 10px 16px;\r\n        height: 74px;\r\n        border-bottom: 1px solid #d9dee5;\r\n        background: #ffffff;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: flex-start;\r\n    }\r\n\r\n    body.absence-list-route .home-header .logo {\r\n        margin-top: 0 !important;\r\n        margin-left: 0 !important;\r\n        margin-right: auto !important;\r\n        margin-bottom: 0 !important;\r\n        width: auto;\r\n        height: auto;\r\n        min-height: 0;\r\n        background: none !important;\r\n        display: inline-flex;\r\n        align-items: baseline;\r\n        gap: 0;\r\n        line-height: 1;\r\n        text-transform: none;\r\n        font-family: 'Poppins' !important;\r\n        justify-content: flex-start;\r\n        text-align: left;\r\n        align-self: center;\r\n    }\r\n\r\n    body.absence-list-route .home-header .logo::before {\r\n        content: 'Agema';\r\n        color: #1f1f1f;\r\n        font-size: clamp(34px, 8vw, 58px);\r\n        font-weight: 500;\r\n        letter-spacing: -0.02em;\r\n    }\r\n\r\n    body.absence-list-route .home-header .logo::after {\r\n        content: 'HOME';\r\n        color: #2280b3;\r\n        font-size: clamp(34px, 8vw, 58px);\r\n        font-weight: 700;\r\n        letter-spacing: -0.02em;\r\n    }\r\n\r\n    body.absence-list-route .home-header .mobile-header-actions {\r\n        margin-left: 12px;\r\n        display: inline-flex;\r\n        align-items: center;\r\n        gap: 0;\r\n    }\r\n\r\n    body.absence-list-route .home-header .add-btn-header-outline {\r\n        width: 40px;\r\n        height: 40px;\r\n        border-radius: 50%;\r\n        border: 3px solid #1f84b9;\r\n        background: #f3f8fb;\r\n        box-shadow:\r\n            0 0 0 4px rgba(31, 132, 185, 0.2),\r\n            0 6px 14px rgba(31, 132, 185, 0.35);\r\n    }\r\n\r\n    body.absence-list-route .home-header .add-btn-header-outline svg {\r\n        font-size: 24px;\r\n        color: #1f84b9 !important;\r\n    }\r\n\r\n    .only-mobile .padding-body-small {\r\n        padding: 18px 16px 12px;\r\n    }\r\n\r\n    .only-mobile .holiday-info,\r\n    .only-mobile .holiday-toggle,\r\n    .only-mobile p,\r\n    .only-mobile .bodySmall {\r\n        color: #1177ad;\r\n    }\r\n\r\n    .only-mobile .holiday-label {\r\n        color: #1177ad;\r\n    }\r\n\r\n    .only-mobile .holiday-info {\r\n        font-size: clamp(15px, 2.2vw, 33px);\r\n        margin-top: 6px;\r\n        line-height: 1.18;\r\n    }\r\n\r\n    .only-mobile .mt-5 {\r\n        margin-top: 6px;\r\n    }\r\n\r\n    .only-mobile .white-progress {\r\n        height: 6px;\r\n        border-radius: 4px;\r\n        background-color: #d8e2ea;\r\n    }\r\n\r\n    .only-mobile .white-progress .MuiLinearProgress-bar {\r\n        background-color: #1f86ba !important;\r\n    }\r\n\r\n    .only-mobile .holiday-toggle {\r\n        margin-top: 4px;\r\n        font-size: clamp(14px, 2.1vw, 22px);\r\n    }\r\n\r\n    .only-mobile .absence-list p b {\r\n        font-size: clamp(16px, 2.8vw, 24px);\r\n        line-height: 1.15;\r\n        color: #1177ad;\r\n    }\r\n\r\n    .only-mobile .home-container3 {\r\n        gap: 12px;\r\n        display: grid;\r\n        grid-template-columns: 1fr;\r\n    }\r\n\r\n    .only-mobile .absence-card-box {\r\n        background-color: #dfeaf2;\r\n        border-radius: 12px;\r\n        padding: 22px 14px;\r\n        gap: 12px;\r\n    }\r\n\r\n    .only-mobile .absence-item-content.slid {\r\n        transform: translateX(-70px);\r\n    }\r\n\r\n    .only-mobile .absence-card-left {\r\n        flex: 0 0 76px;\r\n    }\r\n\r\n    .only-mobile .absence-type-icon {\r\n        width: 62px;\r\n        height: 62px;\r\n    }\r\n\r\n    .only-mobile .absence-card-center .feature-card-text {\r\n        margin-bottom: 10px;\r\n        line-height: 1.1;\r\n        font-size: clamp(16px, 2.9vw, 38px);\r\n    }\r\n\r\n    .only-mobile .absence-card-center .feature-card-text a,\r\n    .only-mobile .absenceLink {\r\n        color: #27aae4 !important;\r\n        font-weight: 700;\r\n    }\r\n\r\n    .only-mobile .absenceApprovedLink {\r\n        color: #27aae4 !important;\r\n        font-weight: 700;\r\n    }\r\n\r\n    .only-mobile .absenceRejectLink {\r\n        color: #ef6a55 !important;\r\n        font-weight: 700;\r\n    }\r\n\r\n    .only-mobile .absence-card-center .bodySmall {\r\n        color: #0d4d8d;\r\n        line-height: 1.25;\r\n        font-size: clamp(14px, 2.2vw, 28px);\r\n    }\r\n\r\n    .only-mobile .status-icon {\r\n        font-size: 46px !important;\r\n        color: #2382b4 !important;\r\n        opacity: 1;\r\n        transform: none;\r\n    }\r\n\r\n    .only-mobile .absence-card-box-rejected {\r\n        background-color: #f8e4e1;\r\n    }\r\n\r\n    .only-mobile .absence-card-box-approved .absence-type-icon,\r\n    .only-mobile .absence-card-box-pending .absence-type-icon {\r\n        filter: brightness(0) saturate(100%) invert(28%) sepia(87%)\r\n            saturate(1384%) hue-rotate(176deg) brightness(89%) contrast(88%);\r\n    }\r\n\r\n    .only-mobile .absence-card-box-rejected .absence-type-icon {\r\n        filter: brightness(0) saturate(100%) invert(58%) sepia(49%)\r\n            saturate(1936%) hue-rotate(324deg) brightness(99%) contrast(89%);\r\n    }\r\n\r\n    .only-mobile .absence-card-box-rejected .feature-card-text,\r\n    .only-mobile .absence-card-box-rejected .feature-card-text a,\r\n    .only-mobile .absence-card-box-rejected .bodySmall,\r\n    .only-mobile .absence-card-box-rejected .bodySmall b,\r\n    .only-mobile .absence-card-box-rejected .absenceRejectLink {\r\n        color: #ef6a55 !important;\r\n    }\r\n\r\n    .only-mobile .absence-card-box-rejected .status-icon {\r\n        color: #ef6a55 !important;\r\n    }\r\n\r\n    .only-mobile .reject-status-icon {\r\n        display: inline-flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n\r\n    .only-mobile .reject-status-icon svg {\r\n        width: 46px;\r\n        height: 46px;\r\n        display: block;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 520px) {\r\n    body.absence-list-route .home-header .logo::before,\r\n    body.absence-list-route .home-header .logo::after {\r\n        font-size: 36px;\r\n    }\r\n\r\n    .only-mobile .absence-list p b {\r\n        font-size: 18px;\r\n    }\r\n}\r\n\r\n@media (prefers-color-scheme: dark) and (max-width: 1024px) {\r\n    body.absence-list-route .home-header .navbarContainer {\r\n        background: #11161d !important;\r\n        border-bottom: 1px solid #26313b;\r\n    }\r\n\r\n    body.absence-list-route .home-header .logo::before {\r\n        color: #f1f5f9;\r\n    }\r\n\r\n    body.absence-list-route .home-header .add-btn-header-outline {\r\n        background: #17222c;\r\n    }\r\n\r\n    body.absence-list-route .absence-list,\r\n    body.absence-list-route .home-hero,\r\n    body.absence-list-route .home-container {\r\n        background: #0b1016 !important;\r\n    }\r\n\r\n    body.absence-list-route .only-mobile .padding-body-small {\r\n        background: #0b1016;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
